import classes from '@/components/Shares/Button.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Button, Group, Stack, Text } from '@mantine/core';
import { Icons } from '../Shares/Icons';
import lineStyle from './VipClub.module.css';
export const VipClubIntro: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack className={lineStyle.border} align="center" py={{
    base: 20,
    sm: 24,
    lg: 48
  }} mt={{
    base: 16,
    sm: 20
  }}>
      <Box>
        <Text ta="center" c="var(--text-white)" className={gunterzBold.className} fz={{
        base: 'sm',
        sm: 'lg',
        lg: 'xl'
      }}>
          {i18n._('Your Adventure Starts Here!')}
        </Text>
        <Text w={{
        sm: 618,
        lg: 564
      }} fz="xs" fw={700} c="var(--text-dark)" tt="uppercase" ta="center">
          {i18n._('Welcome to the PrimeRoll VIP Club, where every game you play brings you closer to leveling up, unlocking incredible rewards, and enjoying exclusive perks.')}
        </Text>
      </Box>

      <Group mt={{
      base: 32,
      sm: 40
    }}>
        <Button h={46} fz={13} className={classes.root} leftSection={<Icons className="icon-pr-line-log-in" fontSize={24} />}>
          {i18n._('Sign up now')}
        </Button>
        <Button fz={13} h={46} className={classes.button_style_2}>
          {i18n._('Learn more')}
        </Button>
      </Group>
    </Stack>;
};